import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchProductCodeById(ref) {
  const { data } = await http(`/admin/product-groups/${ref}`);

  return data;
}

export function useProductCodeById(ref) {
  const { data, ...raResult } = useQuery(["product-groups-code", ref], () =>
    fetchProductCodeById(ref)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

export async function fetchProductCodeByQR(qr) {
  const { data } = await http(`/admin/products/${qr}/qrs`);

  return data;
}

export function useProductCodeByQR(qr) {
  const { data, ...raResult } = useQuery(["product-groups-code-qr", qr], () =>
    fetchProductCodeByQR(qr)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
